const utils = require( './utilities.js' );
const ui = require( './ui.js' );
const dataTableHTML = require( './data-table-html.js' );
// history pushState

function cacheSelectors() {
    let $sel = {
        '$form': $('.form--search'),
        '$dataTable': $('.data-table'),
        '$pagination': $('.pagination')
    };
    $sel.$showFormDiv = $sel.$form.find('.show-form');

    $sel.btn = {
        '$search': $sel.$form.find('.search'),
        '$reset': $sel.$form.find('.reset'),
        '$export': $('.export'),
        '$headerCel': $sel.$dataTable.find('.data-table__header .cel'),
        '$pageBack': $sel.$pagination.find('.page-back'),
        '$pageNext': $sel.$pagination.find('.page-next'),
        '$pageSpecific': $sel.$pagination.find('.page-specific'),
        '$toggleShowForm': $sel.$form.find('.toggle-show-form')
    };
    $sel.input = {
        '$fields': $sel.$form.find('.input'),
        '$page': $sel.$pagination.find('#page'),
        '$pageTotal': $sel.$pagination.find('.pagination__total')
    };
    return $sel;
}

function init() {
    const $sel = cacheSelectors();
    const mode = setMode();
    searchData();

    $sel.btn.$search.on('click', utils.debounce(() => { searchData(); } ));
    $sel.btn.$export.on('click', utils.debounce(() => { searchData('csv'); } ));

    $sel.$dataTable.on('click', '.expand-row', utils.debounce(function(e) {
        if($sel.$dataTable.hasClass('-loading')) {
            return;
        }
        $(e.target).parents('.data-table > .row').toggleClass('active');
    }, 250));

    $sel.$dataTable.on('click', '.download', function() {
        getCarePlan($(this).data('file'));
    });

    $sel.btn.$headerCel.on('click', utils.debounce(function(el) {
        if($(el.target).hasClass('active')) {
            $(el.target).toggleClass('reverse');
            searchData();
        }
        else {
            $sel.btn.$headerCel.removeClass('active');
            $(el.target).addClass('active');
            searchData();
        }
    }));

    $sel.btn.$pageBack.on('click', utils.debounce(function(el) {
        if($(el.target).hasClass('disabled')) {
            return;
        }
        searchData(parseInt($sel.input.$page.val()) - 1);
    }));

    $sel.btn.$pageNext.on('click', utils.debounce(function(el) {
        if($(el.target).hasClass('disabled')) {
            return;
        }
        searchData(parseInt($sel.input.$page.val()) + 1);
    }));

    $sel.btn.$pageSpecific.on('click', utils.debounce(() => {
        searchData($sel.input.$page.val());
    }));

    $sel.$form.on('keydown', (e) => {
        utils.form.handleSubmit(e, searchData);
    });

    $sel.btn.$reset.on('click', () => {
        $sel.input.$fields.filter(':not(#table)').val('');
    });

    $sel.btn.$toggleShowForm.on('click', function(e) {
        $(this).toggleClass('active');
        $('.show-form').toggleClass('active');
        e.preventDefault();
    });

    function searchData(page) {
        ui.loader.show($sel.$dataTable);
        let data = {};
        const $activeSort = $sel.btn.$headerCel.filter('.active');
        data['page'] = page ? page : 1;
        data['table'] = mode;
        if ($activeSort.length) {
            data['sort_by'] = $activeSort.data('sort');
            data['sort_order'] = $activeSort.hasClass('reverse') ? 'DESC' : 'ASC';
        }
        utils.form.prepareRequest($sel.input.$fields, data);
        $sel.$dataTable.addClass('-loading');

        const get = $.ajax({
            method: 'GET',
            url: '/wp-json/alterwood/v1/search_data',
            data: data,
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', $sel.$form.data('nonce') );
            },
        });
        get.done((res) => {
            if(res.status == 'no-filters') {
                errorDataTable('no-filters');
            } else if (res.status === 'error' || (res.data && !res.data.length)) {
                errorDataTable(404);
            } else if (res.status === 'csv') {
                downloadCSV(res.data);
                $sel.$dataTable.removeClass('-loading');
            } else {
                updateDataTable(res.data);
                updatePagination(res.page, res.pages);
                $sel.$dataTable.removeClass('-loading');
                $sel.$showFormDiv.removeClass('active');
                $sel.btn.$toggleShowForm.removeClass('active');
            }
            ui.loader.hide();
        });
    }

    function downloadCSV(data) {
        let csvRows = [];

        const headers = data[0]['detail'] ? Object.assign({}, data[0], data[0]['detail'][0]) : data[0];
        delete headers['detail'];
        csvRows.push(Object.keys(headers).join(','));
        for(let i = 0; i < data.length; i++) {
            if(data[i].detail) {
                for(let j = 0; j < data[i].detail.length; j++) {
                    let row = Object.assign({}, data[i], data[i]['detail'][j]);
                    delete row['detail'];
                    csvRows.push(formatCSVRow(row));
                }
            } else {
                let row = Object.assign({}, data[i]);
                csvRows.push(formatCSVRow(row));
            }
        }

        csvRows = csvRows.join('\n');

        const blob = new Blob([csvRows], { type: 'text/csv;charset=utf-8;' });

        var elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = 'data-'+mode+'.csv';
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }

    function formatCSVRow(row) {
        const values = Object.values(row);
        for(let i = 0; i < values.length; i++) {
            if (typeof values[i] == "string" && (values[i].indexOf("\"") != -1 || values[i].indexOf(",") != -1)) {
                values[i] = values[i].replaceAll("\"", "\"\"");
                values[i] = "\""+values[i]+"\"";
            }
        }
        return values.join(',');
    }

    function updatePagination(page, pages) {
        if(page > 1) {
            $sel.btn.$pageBack.removeClass('disabled');
        }
        else {
            $sel.btn.$pageBack.addClass('disabled');
        }
        if(page < pages) {
            $sel.btn.$pageNext.removeClass('disabled');
        }
        else {
            $sel.btn.$pageNext.addClass('disabled');
        }
        $sel.input.$pageTotal.text(pages);

        let $options = '';
        for(var i = 1; i <= pages; i++) {
            if (i == page) {
                $options += `<option value="${i}" selected>${i}</option>`;
            }
            else {
                $options += `<option value="${i}">${i}</option>`;
            }
        }
        $sel.input.$page.html($options);
    }

    function errorDataTable(err) {
        $sel.$dataTable.find('.data-table__notice').remove();
        $sel.$pagination.hide();
        $sel.btn.$export.hide();
        $sel.$dataTable.find('.row:not(.data-table__header)').remove();
        let msg = '';
        if(err == 404) {
            msg = 'Sorry, there are no results for this search.';
        } else if (err == 'no-filters') {
            msg = 'Add filters to search this table.';
        }
        $sel.$dataTable.append(`<div class="data-table__notice">${msg}</div>`)
    }

    function updateDataTable(data) {
        $sel.$dataTable.find('.row:not(.data-table__header), .data-table__notice').remove();

        $.each(data, function(key, item) {
            $sel.$dataTable.append(dataTableHTML[mode](item));
        });
        $sel.$pagination.show();
        $sel.btn.$export.show();
    }
    function setMode() {
        let mode = $sel.$form.attr('id');
        return mode;
    }
    function getCarePlan(file) {
        if (!utils.form.isProcessing) {
            utils.form.isProcessing = true;
            ui.loader.show();
            const get = $.ajax({
                method: 'GET',
                url: '/wp-json/alterwood/v1/download_care_plan',
                data: { file : file },
                beforeSend: function ( xhr ) {
                    xhr.setRequestHeader( 'X-WP-Nonce', $sel.$form.data('nonce') );
                },
                xhrFields: {
                    responseType: 'arraybuffer'
                },
            });
            get.always((res) => {
                if(res.statusText == 'parsererror') {
                    alert('Error loading care plan!');
                } else {
                    var file = new Blob([res], { type: 'application/pdf', disposition: 'inline' });
                    var fileURL = URL.createObjectURL(file);
                    window.open(fileURL);

                    utils.form.isProcessing = false;
                }
                ui.loader.hide();
                utils.form.isProcessing = false;
            });
        }
    }
}

/**
 * Public API
 *
 * @type {Object}
 */
 module.exports = {
	init: init
};



// WEBPACK FOOTER //
// ./scripts/components/data-table.js